import orderBy from 'lodash/orderBy';

export const getClassroomCourseVersionHashKey = ({ classroomId, courseId }) =>
  `classroomId#${classroomId}_courseId#${courseId}`;

export const getGroupHashKey = ({ classroomId, groupId }) => `classroomId#${classroomId}_groupId#${groupId}`;

export const mapEntitiesToOptions = (entities, { valueColumn = 'id', labelColumn = 'name' } = {}) =>
  Object.values(entities).map(entity => ({ value: entity[valueColumn], label: entity[labelColumn] }));

export const sortEntitiesByIds = ({ entities, ids, direction = 'asc', sortKey }) => {
  const sortedIds = [...ids];

  const findEntityKeyById = id => entities?.[id]?.[sortKey];

  return orderBy(sortedIds, findEntityKeyById, [direction]);
};

export default getClassroomCourseVersionHashKey;



// WEBPACK FOOTER //
// ./containers/entities/helpers.js